import React from 'react';
import { Field as FormikField } from 'formik';

const Field = (props) => {
  return <FormikField {...props} />;
};

export default Field;
